"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectRequestHandler = exports.AUTHORIZATION_REQUEST_HANDLE_KEY = exports.authorizationServiceConfigurationKey = exports.authorizationRequestKey = void 0;
const appauth_1 = require("@openid/appauth");
/**
 * Sourced from RedirectBasedHandler at https://github.com/openid/AppAuth-JS/blob/cf6bb68dfe630c5d5f415bdcc76ea2581f041d8f/src/redirect_based_handler.ts
 *
 * Some customizations were made including:
 *   Remove LocalStorage abstraction so calls can be synchronous.
 *   completeAuthorizationRequestSync - This was customized to include the AuthorizationServiceConfiguration so we don't
 *      need to make an additional network request when logging the user in. We also clear the hash after capturing it.
 *
 */
/** key for authorization request. */
const authorizationRequestKey = (handle) => {
    return `${handle}_STREEM_AUTH_REQUEST`;
};
exports.authorizationRequestKey = authorizationRequestKey;
/** key for authorization service configuration */
const authorizationServiceConfigurationKey = (handle) => {
    return `${handle}_STREEM_AUTH_CONFIG`;
};
exports.authorizationServiceConfigurationKey = authorizationServiceConfigurationKey;
/** key in local storage which represents the current authorization request. */
exports.AUTHORIZATION_REQUEST_HANDLE_KEY = 'STREEM_CURRENT_AUTH_REQUEST';
/**
 * Represents an AuthorizationRequestHandler which uses a standard
 * redirect based code flow.
 */
class RedirectRequestHandler extends appauth_1.AuthorizationRequestHandler {
    constructor(utils = new appauth_1.BasicQueryStringUtils(), crypto = new appauth_1.DefaultCrypto()) {
        super(utils, crypto);
    }
    performAuthorizationRequest(configuration, request) {
        return __awaiter(this, void 0, void 0, function* () {
            const handle = this.crypto.generateRandom(10);
            // before you make request, persist all request related data in local storage.
            const requestJson = yield request.toJson();
            window.localStorage.setItem(exports.AUTHORIZATION_REQUEST_HANDLE_KEY, handle);
            window.localStorage.setItem((0, exports.authorizationRequestKey)(handle), JSON.stringify(requestJson));
            window.localStorage.setItem((0, exports.authorizationServiceConfigurationKey)(handle), JSON.stringify(configuration.toJson()));
            const url = this.buildRequestUrl(configuration, request);
            window.location.assign(url);
        });
    }
    pendingAuthorizationRequest() {
        const handle = window.localStorage.getItem(exports.AUTHORIZATION_REQUEST_HANDLE_KEY);
        return typeof handle === 'string' && handle.length > 0;
    }
    /**
     * Attempts to introspect the contents of storage backend and completes the
     * request.
     */
    completeAuthorizationRequestSync() {
        var _a, _b;
        const handle = window.localStorage.getItem(exports.AUTHORIZATION_REQUEST_HANDLE_KEY);
        if (handle) {
            const request = new appauth_1.AuthorizationRequest(JSON.parse((_a = window.localStorage.getItem((0, exports.authorizationRequestKey)(handle))) !== null && _a !== void 0 ? _a : ''));
            const serviceConfiguration = new appauth_1.AuthorizationServiceConfiguration(JSON.parse((_b = window.localStorage.getItem((0, exports.authorizationServiceConfigurationKey)(handle))) !== null && _b !== void 0 ? _b : ''));
            const queryParams = this.utils.parse(window.location, true /* use hash */);
            const state = queryParams['state'];
            const code = queryParams['code'];
            const error = queryParams['error'];
            const shouldNotify = state === request.state;
            let authorizationResponse = null;
            let authorizationError = null;
            if (shouldNotify) {
                if (error) {
                    // get additional optional info.
                    const errorUri = queryParams['error_uri'];
                    const errorDescription = queryParams['error_description'];
                    authorizationError = new appauth_1.AuthorizationError({
                        error: error,
                        error_description: errorDescription,
                        error_uri: errorUri,
                        state: state,
                    });
                }
                else {
                    authorizationResponse = new appauth_1.AuthorizationResponse({
                        code: code,
                        state: state,
                    });
                }
                // cleanup state
                window.location.hash = '';
                window.localStorage.removeItem(exports.AUTHORIZATION_REQUEST_HANDLE_KEY);
                window.localStorage.removeItem((0, exports.authorizationRequestKey)(handle));
                window.localStorage.removeItem((0, exports.authorizationServiceConfigurationKey)(handle));
                return {
                    request: request,
                    response: authorizationResponse,
                    serviceConfiguration,
                    error: authorizationError,
                };
            }
        }
        return null;
    }
    completeAuthorizationRequest() {
        return Promise.resolve(this.completeAuthorizationRequestSync());
    }
}
exports.RedirectRequestHandler = RedirectRequestHandler;
//# sourceMappingURL=redirect_based_handler.js.map